<template>
  <div class="footer-content">
    <div class="footer-box text-center">
      <div class="typography--body-3 typography--color-secondary">
        {{ $t('footer.brand') }}
      </div>
      <div class="divider"></div>
      <div class="typography--body-3 typography--color-secondary">
        <a class="typography--body-3 typography--color-secondary passive-link-btns clickable" v-on:click="$root.$emit('show::modal', 'terms-policy-modal')">
          {{ $t('footer.terms') }}
        </a>
      </div>
      <div class="divider"></div>
      <div class="typography--body-3 typography--color-secondary">
        <a class="typography--body-3 typography--color-secondary passive-link-btns clickable" v-on:click="$root.$emit('show::modal', 'privacy-policy-modal')">
          {{ $t('footer.privacy') }}
        </a>
      </div>
      <div class="divider"></div>
      <div class="typography--body-3 typography--color-secondary">
        <a class="typography--body-3 typography--color-secondary passive-link-btns clickable" v-on:click="$root.$emit('show::modal', 'operation-policy-modal')">
          {{ $t('footer.operation') }}
        </a>
      </div>
      <div class="divider"></div>
      <div class="typography--body-3 typography--color-secondary">
        <a href="http://support.classting.com/hc/ko/sections/115000081194-%ED%81%B4%EB%9E%98%EC%8A%A4%ED%8C%85-%EB%9F%AC%EB%8B%9D-%EC%82%AC%EC%9A%A9%EB%B2%95"
           target="_blank"
           class="typography--body-3 typography--color-secondary">
          {{ $t('footer.support') }}
        </a>
      </div>
    </div>

    <div>
      <PolicyModal id="terms-policy-modal"
                   v-bind:title="$t('footer.terms')"
                   policy-id="terms">
      </PolicyModal>

      <PolicyModal id="privacy-policy-modal"
                   v-bind:title="$t('footer.privacy')"
                   policy-id="privacy">
      </PolicyModal>

      <PolicyModal id="operation-policy-modal"
                   v-bind:title="$t('footer.operation')"
                   policy-id="operation">
      </PolicyModal>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'footer-content',
  };
</script>

<style lang="scss">
  .footer-box {
    &>div {
      display: inline-block;

      &.typography--body-3 {
        padding-left: 16px;
        padding-right: 16px;
      }

      &.divider {
        margin-top: 3px;
        width: 2px;
        height: 12px;
        padding: 0;
        border: solid 1px rgba(0, 0, 0, 0.12);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterContent.vue